/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { CommunityGameModel, CommunityGameModelType } from './CommunityGameModel'
import { CommunityGameModelSelector } from './CommunityGameModel.base'
import { TodayCommunityGamesStatusEnumType } from './TodayCommunityGamesStatusEnum'
import { RootStoreType } from './index'

/**
 * TodayCommunityGamesBase
 * auto generated base class for the model TodayCommunityGamesModel.
 */
export const TodayCommunityGamesModelBase = ModelBase.named('TodayCommunityGames')
  .props({
    __typename: types.optional(types.literal('TodayCommunityGames'), 'TodayCommunityGames'),
    advancedGames: types.union(types.undefined, types.array(types.late(() => CommunityGameModel))),
    beginnerGames: types.union(types.undefined, types.array(types.late(() => CommunityGameModel))),
    isFull: types.union(types.undefined, types.boolean),
    isSetReminderSelected: types.union(types.undefined, types.null, types.boolean),
    maxPlayersN: types.union(types.undefined, types.number),
    minPlayersN: types.union(types.undefined, types.number),
    multipleBlindOptions: types.union(types.undefined, types.boolean),
    nAdvancedTables: types.union(types.undefined, types.number),
    nBeginnerTables: types.union(types.undefined, types.number),
    nowPlaying: types.union(types.undefined, types.number),
    scheduleId: types.union(types.undefined, types.null, types.string),
    status: types.union(types.undefined, TodayCommunityGamesStatusEnumType),
    time: types.union(types.undefined, types.frozen()),
    winners: types.union(types.undefined, types.null, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TodayCommunityGamesModelSelector extends QueryBuilder {
  get isFull() {
    return this.__attr('isFull')
  }
  get isSetReminderSelected() {
    return this.__attr('isSetReminderSelected')
  }
  get maxPlayersN() {
    return this.__attr('maxPlayersN')
  }
  get minPlayersN() {
    return this.__attr('minPlayersN')
  }
  get multipleBlindOptions() {
    return this.__attr('multipleBlindOptions')
  }
  get nAdvancedTables() {
    return this.__attr('nAdvancedTables')
  }
  get nBeginnerTables() {
    return this.__attr('nBeginnerTables')
  }
  get nowPlaying() {
    return this.__attr('nowPlaying')
  }
  get scheduleId() {
    return this.__attr('scheduleId')
  }
  get status() {
    return this.__attr('status')
  }
  get time() {
    return this.__attr('time')
  }
  get winners() {
    return this.__attr('winners')
  }
  advancedGames(
    builder:
      | string
      | CommunityGameModelSelector
      | ((selector: CommunityGameModelSelector) => CommunityGameModelSelector)
      | undefined
  ) {
    return this.__child('advancedGames', CommunityGameModelSelector, builder)
  }
  beginnerGames(
    builder:
      | string
      | CommunityGameModelSelector
      | ((selector: CommunityGameModelSelector) => CommunityGameModelSelector)
      | undefined
  ) {
    return this.__child('beginnerGames', CommunityGameModelSelector, builder)
  }
}
export function selectFromTodayCommunityGames() {
  return new TodayCommunityGamesModelSelector()
}

export const todayCommunityGamesModelPrimitives =
  selectFromTodayCommunityGames().isFull.isSetReminderSelected.maxPlayersN.minPlayersN.multipleBlindOptions
    .nAdvancedTables.nBeginnerTables.nowPlaying.scheduleId.status.time.winners
